import { RM12_01 } from "./RM12_01";

export const RM12 = {
    "columns": 4,
    "rows": 1,
    "visual": {
        "id": 1,
        "type": "bar",
        "colorTheme": 'colorTheme3',
        "title": "INCIDENTAL CALLS",
        "orientation": "vertical",
        "xAxis": "",
        "yAxis": "",
        "binding": {
            "data": {
                "series": [
                    {
                        "name": 'Count',
                        "value": 'TotalCount',
                        "type": 'column'

                    }
                ],
                "title": 'SubCycle',
                "endpoint": "RM12",
                "parameters": [
                    { key: "CycleCode", value: "CP1" },
                    { key: "CycleYear", value: "2026" },
                    { "key": "RegionCode", "value": "" },
                ]
            },
            "context": {
                "point": {
                    "onClick": RM12_01
                }
            }
        }
    }
}